import {
	DocumentApprovalRulesResponse,
	DocumentApprovalUpdateRequest
} from "@/Contracts/DocumentApprovals";
import {
	DocumentApproval,
	DocumentApprovalCreateRequest
} from "@/Contracts/DocumentApprovals";
import axios, { AxiosResponse } from "axios";
import {
	AutomationEnums,
	SalesActivityAutomationMetadataResponse,
	SalesActivityAutomationTriggerActionTypes
} from "@/Contracts/Others/SalesActivity";
import {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest
} from "@/Utils/Service/BackendService";

const getSalesActivityAutomationMetadataUrl =
	"/v2/automation/sales/metadata?trigger_action_type={trigger_action_type}&trigger_entity_type={trigger_entity_type}";
const createDocumentApprovalRuleURL = "/{api_version}/automation/approval/";
const getDocumentApprovalRuleURL = "/v3/automation/approval/:id";
const updateDocumentApprovalRuleURL = "/{api_version}/automation/approval/:id";
const deleteDocumentApprovalRuleURL = "/{api_version}/automation/approval/:id";
const getAllDocumentApprovalRulesURL = "/v3/automation/approval/";
const getAllDocumentApprovalRulesBySalesURL =
	"/v2/automation/sales?for_approval_automation=true";
const getDocumentApprovalRuleBySalesURL =
	"/v2/automation/sales/:id?for_approval_automation=true";

export const getDocumentFilterMetadata =
	async (): Promise<SalesActivityAutomationMetadataResponse> => {
		try {
			let url = getSalesActivityAutomationMetadataUrl;
			url = url.replace(
				"{trigger_action_type}",
				SalesActivityAutomationTriggerActionTypes.Updated
			);
			url = url.replace(
				"{trigger_entity_type}",
				AutomationEnums.ApprovalAutomation
			);

			const response: AxiosResponse<SalesActivityAutomationMetadataResponse> =
				await axios(getRequest(url, null, true, false, false));
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const createDocumentApprovalRule = async (
	documentApprovalRuleRequest: DocumentApprovalCreateRequest,
	apiVersion = "v2"
): Promise<DocumentApproval> => {
	try {
		const response: AxiosResponse<DocumentApproval> = await axios(
			postRequest(
				createDocumentApprovalRuleURL.replace(
					"{api_version}",
					apiVersion
				),
				documentApprovalRuleRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getDocumentApprovalRule = async (
	documentApprovalRuleId: string
): Promise<DocumentApproval> => {
	try {
		const response: AxiosResponse<DocumentApproval> = await axios(
			getRequest(
				getDocumentApprovalRuleURL.replace(
					":id",
					documentApprovalRuleId
				),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateDocumentApprovalRule = async (
	documentApprovalRuleRequest: DocumentApprovalUpdateRequest,
	apiVersion = "v2"
): Promise<DocumentApproval> => {
	try {
		const response: AxiosResponse<DocumentApproval> = await axios(
			putRequest(
				updateDocumentApprovalRuleURL
					.replace("{api_version}", apiVersion)
					.replace(":id", documentApprovalRuleRequest.id),
				documentApprovalRuleRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAllDocumentApprovalRules =
	async (): Promise<DocumentApprovalRulesResponse> => {
		try {
			const response: AxiosResponse<DocumentApprovalRulesResponse> =
				await axios(
					getRequest(
						getAllDocumentApprovalRulesURL,
						null,
						true,
						false,
						false
					)
				);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const getAllDocumentApprovalRulesBySales =
	async (): Promise<DocumentApprovalRulesResponse> => {
		try {
			const response: AxiosResponse<DocumentApprovalRulesResponse> =
				await axios(
					getRequest(
						getAllDocumentApprovalRulesBySalesURL,
						null,
						true,
						false,
						false
					)
				);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};
export const getDocumentApprovalRuleBySales = async (
	documentApprovalRuleId: string
): Promise<DocumentApproval> => {
	try {
		const response: AxiosResponse<DocumentApproval> = await axios(
			getRequest(
				getDocumentApprovalRuleBySalesURL.replace(
					":id",
					documentApprovalRuleId
				),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteDocumentApprovalRule = async (
	id: string,
	apiVersion = "v2"
): Promise<any> => {
	try {
		const response: AxiosResponse<any> = await axios(
			deleteRequest(
				deleteDocumentApprovalRuleURL
					.replace("{api_version}", apiVersion)
					.replace(":id", id),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
